@use '~/vendor/cxy/scss/styles/index.scss' as cxy;
@use '../../Table/styles/Table.module.scss' as table;

$containerName: gridContainer;

.gridTableWrapper {
  --grid-span-single: span 1;
  --grid-span-wide: span 2;
  --grid-span-all: span 3;

  container-name: $containerName;
  container-type: inline-size;

  .gridTable {
    display: grid;

    .gridTableRow {
      display: grid;
      grid-template-columns: repeat(var(--mobileColumns, auto-fit), minmax(0, 1fr));

      .gridTableColumn {
        background-color: table.$color-background;
      }
    }

    .gridTableCaption,
    .gridTableHeader,
    .gridTableBody,
    .gridTableFooter {
      grid-column: 1 / -1;
      grid-row: var(--gridRow);
    }

    .gridTableCell {
      order: var(--cellOrder);

      &:last-of-type:not(.fullWidthMobile) {
        grid-column-start: var(--start);
      }
    }

    .gridTableColumn,
    .gridTableCell {
      &.fullWidthMobile {
        grid-column: var(--grid-span-all);
      }
    }
  }
}

.gridTableWrapper {
  @include cxy.container-size($containerName, 'tablet-wide') {
    .gridTable {
      &.hasMultipleTableBodies {
        grid-template-columns: minmax(35%, min-content) auto;
      }

      .gridTableCaption {
        grid-row: 1;
        grid-column: auto;
      }

      .gridTableHeader {
        grid-row: 1;
        grid-column: auto;

        .gridTableRow .gridTableColumn {
          background-color: table.$color-heading;
        }
      }

      .gridTableRow {
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      }

      .gridTableBody {
        grid-row: 2;
        grid-column: auto;
      }

      .gridTableFooter {
        grid-row: 3;
        grid-column: 1 / var(--gridWidth);
      }

      .gridTableCell {
        order: initial;

        &:last-of-type:not(.fullWidthMobile) {
          grid-column-start: auto;
        }
      }

      .gridTableColumn,
      .gridTableCell {
        &.fullWidthMobile {
          grid-column: var(--grid-span-single);
        }

        &.mainColumn {
          grid-column: var(--grid-span-all);
        }
      }
    }
  }
}
